module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    ref: "pagefoot"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "background-color": "#053a7a"
    }
  }, [_c('div', {
    staticClass: "container bluebg"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-12 col-lg-10 offset-lg-1"
  }, [_c('hr', {
    staticStyle: {
      "border": "0"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border-top": "1px solid #31629e"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row text-left"
  }, [_c('div', {
    staticClass: "col-12 col-lg-4 mobile-footer-margin"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://amcredit.com"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "72px",
      "margin-bottom": "0.5rem"
    },
    attrs: {
      "src": require('../../assets/imgs/logo_white.png'),
      "srcset": require('../../assets/imgs/logo-white-320w.png') +
        ' 320w, ' +
        require('../../assets/imgs/logo-white-640w.png') +
        ' 640w',
      "alt": "American Credit Logo White",
      "width": "283",
      "height": "72"
    }
  })])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "0.5rem"
    }
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('a', {
    attrs: {
      "href": _vm.AndroidApp,
      "rel": "nofollow",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "src": require("../../assets/imgs/google_play_black.png"),
      "alt": "American Credit mobile app in Google Play",
      "width": "164",
      "height": "48"
    }
  })])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(5), _vm._m(6)])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-1 col-md-1"
  })]), _vm._v(" "), _c('br')])]), _vm._v(" "), _vm._m(11)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-lg-3 col-6 pt-3 text-lg-left text-center col-no-padding"
  }, [_c('a', {
    attrs: {
      "href": "https://amcredit.com/why-american-credit"
    }
  }, [_c('h5', {
    staticClass: "footer-text",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("\n                  Why American Credit\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-1 col-6 pt-3 text-lg-left text-center col-no-padding"
  }, [_c('a', {
    attrs: {
      "href": "https://amcredit.com/invest"
    }
  }, [_c('h5', {
    staticClass: "footer-text",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("\n                  Investor\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 col-6 pt-3 col-no-padding"
  }, [_c('a', {
    attrs: {
      "href": "https://amcredit.com/contact-us"
    }
  }, [_c('h5', {
    staticClass: "footer-text",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("\n                  Contact Us\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 offset-lg-1 col-6 pt-3 text-sm-right col-no-padding"
  }, [_c('a', {
    attrs: {
      "href": "",
      "onclick": "document.body.scrollTop = 0; document.documentElement.scrollTop = 0; return false;"
    }
  }, [_c('h5', {
    staticClass: "footer-text",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("\n                  Back to Top\n                ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "footer-phone-number",
    staticStyle: {
      "font-weight": "700"
    },
    attrs: {
      "href": "tel:1855-904-0188"
    }
  }, [_c('span', [_c('i', {
    staticClass: "phone-icon fa fa-phone",
    staticStyle: {
      "padding-right": "8px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("855-904-0188\n                    ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://youtu.be/7v1c7cM19l0",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "40px"
    },
    attrs: {
      "src": require("../../assets/imgs/american_credit_demo_video.png"),
      "alt": "american credit demo video",
      "width": "125",
      "height": "40"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    staticClass: "footer-text",
    attrs: {
      "href": "https://amcredit.com/sitemap"
    }
  }, [_vm._v(" Sitemap ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-6"
  }, [_c('a', {
    attrs: {
      "href": "https://apps.apple.com/us/app/amcredit/id1489544972#?platform=iphone",
      "rel": "nofollow",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "src": require("../../assets/imgs/app_store_black.png"),
      "alt": "American Credit mobile app in App Store",
      "width": "162",
      "height": "48"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://amcredit.com/equipment-financing-landing-page-1"
    }
  }, [_c('span', {
    staticClass: "footer-text",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("\n                      Landing Page to Equipment Finance\n                    ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://amcredit.com/working-capital-landing-page"
    }
  }, [_c('span', {
    staticClass: "footer-text",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("\n                      Landing Page for Working Capital\n                    ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-lg-8 mobile-footer-margin"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6 col-lg-3"
  }, [_c('h5', {
    staticClass: "footer-title"
  }, [_vm._v("SERVICES")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    staticClass: "footer-text",
    attrs: {
      "href": "https://amcredit.com/equipment-loan"
    }
  }, [_vm._v("Asset-Based Loans")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "footer-text",
    attrs: {
      "href": "https://amcredit.com/invoice-factoring"
    }
  }, [_vm._v("Invoice/AR Factoring")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "footer-text",
    attrs: {
      "href": "https://amcredit.com/vendor-financing"
    }
  }, [_vm._v("Vendor Financing")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-3"
  }, [_c('h5', {
    staticClass: "footer-title"
  }, [_vm._v("RESOURCES")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    staticClass: "footer-text",
    staticStyle: {
      "white-space": "nowrap"
    },
    attrs: {
      "href": "https://amcredit.com/loan-calculator"
    }
  }, [_vm._v("Loan Calculator")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "footer-text",
    staticStyle: {
      "white-space": "nowrap"
    },
    attrs: {
      "href": "https://amcredit.com/roi-calculator"
    }
  }, [_vm._v("ROI Calculator")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "footer-text",
    attrs: {
      "href": "https://amcredit.com/faq"
    }
  }, [_vm._v("FAQs")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "footer-text",
    attrs: {
      "href": "https://amcredit.com/blog"
    }
  }, [_vm._v("Blog")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-2"
  }, [_c('h5', {
    staticClass: "footer-title"
  }, [_vm._v("COMPANY")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    staticClass: "footer-text",
    attrs: {
      "href": "https://amcredit.com/partners"
    }
  }, [_vm._v("Partners")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "footer-text",
    attrs: {
      "href": "https://amcredit.com/careers"
    }
  }, [_vm._v("Careers")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "footer-text",
    attrs: {
      "href": "https://amcredit.com/about-us"
    }
  }, [_vm._v("About Us")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "footer-text",
    attrs: {
      "href": "https://amcredit.com/team"
    }
  }, [_vm._v("Team")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-4"
  }, [_c('h5', {
    staticClass: "footer-title"
  }, [_vm._v("INDUSTRIES")]), _vm._v(" "), _c('ul', {
    staticClass: "mb-3"
  }, [_c('li', [_c('a', {
    staticClass: "footer-text",
    attrs: {
      "href": "https://amcredit.com/industries/commercial-truck-financing"
    }
  }, [_vm._v("Commercial Trucking Loans")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "footer-text",
    attrs: {
      "href": "https://amcredit.com/industries/loans-for-contractors"
    }
  }, [_vm._v("Contracting Loans")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "footer-text",
    attrs: {
      "href": "https://amcredit.com/industries/commercial-construction-loans"
    }
  }, [_vm._v("Construction Loans")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "footer-text",
    attrs: {
      "href": "https://amcredit.com/industries/manufacturing-financing"
    }
  }, [_vm._v("Manufacturing Loans")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "footer-text",
    attrs: {
      "href": "https://amcredit.com/industries/excavator-financing"
    }
  }, [_vm._v("Excavating Loans")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "footer-text",
    attrs: {
      "href": "https://amcredit.com/industries/loans-for-restaurants"
    }
  }, [_vm._v("Restaurant Loans")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "footer-text",
    attrs: {
      "href": "https://amcredit.com/industries/loans-for-landscapers"
    }
  }, [_vm._v("Landscaping Loans")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "footer-text",
    attrs: {
      "href": "https://amcredit.com/industries/transportation-business-loans"
    }
  }, [_vm._v("Transportation Loans")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "footer-text",
    attrs: {
      "href": "https://amcredit.com/industries/commercial-vehicle-loans"
    }
  }, [_vm._v("Commercial Auto Loans")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "footer-text",
    attrs: {
      "href": "https://amcredit.com/industries/loans-for-farmers"
    }
  }, [_vm._v("Farming Loans")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "footer-text",
    attrs: {
      "href": "https://amcredit.com/industries/commercial-real-estate-loans"
    }
  }, [_vm._v("Commercial Real Estate Loans")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "footer-text",
    attrs: {
      "href": "https://amcredit.com/industries/working-capital-financing"
    }
  }, [_vm._v("Working Capital Financing")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-lg-7 mobile-footer-margin"
  }, [_c('div', {
    staticClass: "h7",
    staticStyle: {
      "margin-top": "8px",
      "font-family": "Montserrat",
      "font-size": "14px",
      "font-weight": "500"
    }
  }, [_c('a', {
    staticClass: "footer-text",
    attrs: {
      "href": "https://amcredit.com/terms-of-use"
    }
  }, [_vm._v("Terms of Uses")]), _vm._v("\n                |\n                "), _c('a', {
    staticClass: "footer-text",
    attrs: {
      "href": "https://amcredit.com/privacy-policy"
    }
  }, [_vm._v("Privacy Policy")]), _vm._v("\n                |\n                "), _c('a', {
    staticClass: "footer-text",
    attrs: {
      "href": "https://amcredit.com/communication-policy"
    }
  }, [_vm._v("Consumer Communication Policy")]), _vm._v("\n                |\n                "), _c('a', {
    staticClass: "footer-text",
    attrs: {
      "href": "https://amcredit.com/accessibility-policy"
    }
  }, [_vm._v("Accessibility Policy")]), _c('br'), _vm._v("© 2023 American Credit"), _c('sup', [_vm._v("®")]), _vm._v(", Inc. All right\n                Reserved\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-7 col-lg-3 pt-2 text-sm-center"
  }, [_c('span', {
    staticClass: "d-inline-flex"
  }, [_c('a', {
    staticClass: "eshzbus",
    staticStyle: {
      "display": "block",
      "position": "relative",
      "overflow": "hidden",
      "width": "93px",
      "height": "35px",
      "margin": "0px",
      "padding": "0px"
    },
    attrs: {
      "id": "bbblink",
      "href": "https://www.bbb.org/us/ca/palo-alto/profile/financial-services/american-credit-1216-1079741#bbbseal",
      "title": "American Credit, Inc is a BBB Accredited Financial Service in Palo Alto, CA",
      "rel": "nofollow",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "padding": "0px",
      "border": "none"
    },
    attrs: {
      "id": "bbblinkimg",
      "src": "https://seal-sanjose.bbb.org/logo/eshzbus/american-credit-1079741.png",
      "alt": "American Credit, Inc is a BBB Accredited Financial Service in Palo Alto, CA",
      "width": "93",
      "height": "35"
    }
  })]), _vm._v("\n                 \n                "), _c('img', {
    attrs: {
      "src": require("../../assets/imgs/equal_housing.jpg"),
      "alt": "American Credit Equal Housing",
      "width": "36",
      "height": "35"
    }
  }), _vm._v("\n                 \n                "), _c('a', {
    attrs: {
      "href": "https://www.uschamber.com"
    }
  }, [_c('img', {
    attrs: {
      "alt": "U.S. Chamber of Commerce Member 2021",
      "src": "https://www.uschamber.com/assets/images/USCC_Webstickers_2022_234x75.png",
      "title": "U.S. Chamber of Commerce Member",
      "height": "35"
    }
  })]), _vm._v("\n                 \n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-5 col-lg-2 py-2 text-center"
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/amcredits",
      "rel": "nofollow",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "30px"
    },
    attrs: {
      "src": require("../../assets/imgs/fb.png"),
      "alt": "American Credit Facebook",
      "width": "30",
      "height": "30"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://americancredit.business.site/",
      "rel": "nofollow",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "30px"
    },
    attrs: {
      "src": require("../../assets/imgs/GooglePlus.png"),
      "alt": "American Credit GooglePlus",
      "width": "30",
      "height": "30"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.linkedin.com/company/amcredit",
      "rel": "nofollow",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "30px"
    },
    attrs: {
      "src": require("../../assets/imgs/LinkedIn.png"),
      "alt": "American Credit LinkedIn",
      "width": "30",
      "height": "30"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://twitter.com/amcredit_com",
      "rel": "nofollow",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "30px"
    },
    attrs: {
      "src": require("../../assets/imgs/twitter.png"),
      "alt": "American Credit Twitter",
      "width": "30",
      "height": "30"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "background-color": "#00234d"
    }
  }, [_c('div', {
    staticClass: "container drakbluebg footer-tail"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 h7",
    staticStyle: {
      "font-family": "Montserrat",
      "color": "#759fd1",
      "font-size": "12px",
      "font-weight": "600",
      "line-height": "24px"
    }
  }, [_vm._v("\n            Certain financing may be made or arranged pursuant to California\n            Financing Law - License No. 60DBO-78243 and NMLS ID: 1686352.\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-10 offset-lg-1 h7 text-center",
    staticStyle: {
      "font-family": "Montserrat",
      "color": "#759fd1",
      "font-size": "12px",
      "font-weight": "500",
      "line-height": "21px"
    }
  }, [_vm._v("\n          No monthly or maintenance fees. Wire Transfer Fees may apply.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-10 offset-lg-1 h7 text-center",
    staticStyle: {
      "font-family": "Montserrat",
      "color": "#759fd1",
      "font-size": "12px",
      "font-weight": "500",
      "line-height": "21px"
    }
  }, [_vm._v("\n          Terms and conditions apply. American Credit®, Inc is a Delaware\n          registered company and qualified to do business in California.\n          American Credit®, American Micro Credit®, and Amcredit® are\n          registered trademarks of American Credit, Inc. The company logo is a\n          registered logo of American Credit, Inc. All rights reserved.\n        ")])]), _vm._v(" "), _c('br')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2092a707"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Footer.vue
// module id = 1937
// module chunks = 5